import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { NormasTeachingCouponDTO } from "./useNormasTeachingCouponById.ts";

export function useSetNormasTeachingCouponStatus() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);
  const setNormasTeachingCouponStatus = async (input: {
    couponId: string;
    isActive: boolean;
  }): Promise<NormasTeachingCouponDTO> => {
    try {
      setLoading(true);
      const { data } =
        await createAxiosInstance().post<NormasTeachingCouponDTO>(
          `/coupons/status`,
          input,
        );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return {
    setNormasTeachingCouponStatus,
    loading,
  };
}
